export function LoadingScreen({ message }: { message: string }) {
  return (
    <main className="loading-screen" aria-live="polite" aria-busy="true">
      <div className="loading-emblem" aria-hidden="true">✿</div>
      <p>{message}</p>
      <span aria-hidden="true"><i /></span>
    </main>
  );
}
